import app from 'flarum/common/app';
import trustedHtml from '../utils/trustedHtml';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/utils/humanTime';
import extractText from 'flarum/common/utils/extractText';
import getBadgeSvg, { getBadgeSize } from '../utils/getBadgeSvg';
import secondaryName from '../utils/secondaryName';
import { resolveTierForUser, getTierColor, sanitiseDescription } from '../utils/tiers';
export default class VerifiedPopover extends Component {
  // O cartão só é montado no primeiro hover/foco, com m.render num nó próprio:
  // o CommentPost retém a subárvore do post e ignoraria um redraw do pai.
  activated = false;
  host = null;
  content = () => null;
  activate = e => {
    e.redraw = false;
    if (this.activated || !this.host) return;
    this.activated = true;
    m.render(this.host, this.content());
  };
  onupdate(vnode) {
    super.onupdate(vnode);
    if (this.activated && this.host) m.render(this.host, this.content());
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.host) m.render(this.host, null);
  }
  view() {
    const {
      user
    } = this.attrs;
    if (!user || !user.isVerified || !user.isVerified()) return null;
    const tier = resolveTierForUser(user);
    const color = getTierColor(tier);
    const size = this.attrs.size || getBadgeSize();
    const badgeStyle = {
      '--verified-size': size
    };
    if (color) badgeStyle.color = color;
    const verifiedAt = user.verifiedAt && user.verifiedAt();
    const ariaLabel = tier && tier.label ? tier.label : extractText(app.translator.trans('ramon-verified.lib.tooltip'));

    // A descrição já veio sanitizada, mas é sanitizada de novo aqui porque um
    // tier montado fora do normalise não pode levar HTML cru ao m.trust.
    const tierDescription = tier && tier.description ? tier.description : null;
    const headline = tierDescription ? trustedHtml(sanitiseDescription(tierDescription)) : app.translator.trans('ramon-verified.lib.popover.headline');
    const learnMoreUrl = tier && tier.learnMoreUrl ? tier.learnMoreUrl : '';
    const tierClass = tier ? `VerifiedBadge--tier-${tier.id}` : '';

    // Sem --tier-color o CSS cai na cor primária do tema.
    const popoverStyle = {};
    if (color) popoverStyle['--tier-color'] = color;
    this.content = () => this.popover(user, tier, color, verifiedAt, headline, learnMoreUrl);
    return m("span", {
      className: "VerifiedPopover-anchor",
      "data-tier": tier ? tier.id : undefined,
      style: popoverStyle,
      onmouseenter: this.activate,
      onfocusin: this.activate
    }, m("span", {
      className: 'VerifiedBadge VerifiedBadge--inAnchor ' + tierClass,
      style: badgeStyle,
      role: "img",
      "aria-label": ariaLabel,
      tabIndex: 0
    }, trustedHtml(getBadgeSvg(tier))), m("span", {
      className: "VerifiedPopover-host",
      oncreate: v => this.host = v.dom
    }));
  }
  popover(user, tier, color, verifiedAt, headline, learnMoreUrl) {
    return m("span", {
      className: "VerifiedPopover",
      role: "tooltip"
    }, m("span", {
      className: "VerifiedPopover-arrow",
      "aria-hidden": "true"
    }), m("span", {
      className: "VerifiedPopover-header"
    }, m("span", {
      className: "VerifiedPopover-headerIcon"
    }, trustedHtml(getBadgeSvg(tier))), m("span", {
      className: "VerifiedPopover-headerText"
    }, headline, learnMoreUrl && m('[', null, ' ', m("a", {
      className: "VerifiedPopover-learnMore",
      href: learnMoreUrl,
      target: "_blank",
      rel: "noopener noreferrer"
      // As regras de `a` do core vencem por especificidade em alguns contextos.
      ,
      style: color ? {
        color
      } : undefined
    }, app.translator.trans('ramon-verified.lib.popover.learn_more'))))), m("span", {
      className: "VerifiedPopover-body"
    }, m("span", {
      className: "VerifiedPopover-user"
    }, m("span", {
      className: "VerifiedPopover-avatar"
    }, m(Avatar, {
      user: user
    })), m("span", {
      className: "VerifiedPopover-userText"
    }, m("span", {
      className: "VerifiedPopover-displayName"
    }, user.displayName()), secondaryName(user) && m("span", {
      className: "VerifiedPopover-username"
    }, secondaryName(user)))), m("span", {
      className: "VerifiedPopover-meta"
    }, verifiedAt ? app.translator.trans('ramon-verified.lib.popover.verified_on', {
      date: extractText(humanTime(verifiedAt))
    }) : app.translator.trans('ramon-verified.lib.popover.verified_no_date'))));
  }
}
flarum.reg.add('ramon-verified', 'common/components/VerifiedPopover', VerifiedPopover);